import { createContext, useContext } from 'react';

export type ModalContextValue = {
  depth: number;
  container: HTMLElement | null;
};

export const ModalContext = createContext<ModalContextValue | null>(null);

export function useModalContext(): ModalContextValue | null {
  return useContext(ModalContext);
}
